<template>
  <div class="PromoCard" :class="{ compact, page }">
    <div class="header">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="white" d="m8.85 17.825l3.15-1.9l3.15 1.925l-.825-3.6l2.775-2.4l-3.65-.325l-1.45-3.4l-1.45 3.375l-3.65.325l2.775 2.425l-.825 3.575ZM5.825 22l1.625-7.025L2 10.25l7.2-.625L12 3l2.8 6.625l7.2.625l-5.45 4.725L18.175 22L12 18.275L5.825 22ZM12 13.25Z"/></svg>
      <span>{{ promo.label }}</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="white" d="m8.85 17.825l3.15-1.9l3.15 1.925l-.825-3.6l2.775-2.4l-3.65-.325l-1.45-3.4l-1.45 3.375l-3.65.325l2.775 2.425l-.825 3.575ZM5.825 22l1.625-7.025L2 10.25l7.2-.625L12 3l2.8 6.625l7.2.625l-5.45 4.725L18.175 22L12 18.275L5.825 22ZM12 13.25Z"/></svg>
    </div>

    <div class="body">
      <p class="subtitle">{{ promo.subtitle }}</p>

      <div class="section">
        <p class="sectionTitle">📅 Период действия акции:</p>
        <p class="sectionText">с {{ promo.period.from }} по {{ promo.period.to }}</p>
      </div>

      <div class="section conditionsSection">
        <p class="sectionTitle">✨ Условия акции:</p>
        <ul>
          <li
            v-for="(condition, index) in promo.conditions"
            :key="index"
            v-html="formatText(condition)"
          />
        </ul>
      </div>

      <div class="section">
        <p class="sectionTitle">✅ Забронировать по акции можно:</p>
        <p class="sectionText">
          на официальном сайте:
          <a :href="promo.booking.url" target="_blank" rel="noopener">{{ promo.booking.site }}</a>
        </p>
      </div>

      <div class="section">
        <p class="sectionTitle">📞 Или по телефонам:</p>
        <div class="phonesGrid">
          <a
            v-for="(phone, index) in promo.phones"
            :key="index"
            :href="'tel:' + phoneToHref(phone)"
            class="phoneLink"
          >{{ phoneToHref(phone) }}</a>
        </div>
      </div>

      <div class="section important">
        <p class="sectionTitle importantTitle">! ВАЖНО !</p>
        <p class="sectionText" v-html="formatText(promo.important)" />
      </div>

      <p class="footer">{{ promo.footer }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PromoCard',
  props: {
    promo: { type: Object, required: true },
    compact: { type: Boolean, default: false },
    page: { type: Boolean, default: false },
  },
  methods: {
    phoneToHref(phone) {
      return phone.replace(/[^\d+]/g, '')
    },
    formatText(text) {
      return text.replace(/«СЕМЕЙНЫЙ ЛЮКС»/gi, '<span class="highlightLux">«СЕМЕЙНЫЙ ЛЮКС»</span>')
    },
  },
}
</script>

<style scoped>
.PromoCard {
  background-color: #f6efec;
  overflow: hidden;
  text-align: center;
}

.PromoCard.page {
  margin-bottom: 20px;
}

.PromoCard > .header {
  background-color: #c77a00;
  color: white;
  text-align: center;
  padding: 14px 40px;
  display: grid;
  grid-template-columns: auto 1fr auto;
  column-gap: 10px;
  align-items: center;
  justify-items: center;
}

.PromoCard > .header > span {
  font-weight: bold;
  font-size: 18px;
}

.PromoCard.compact > .header {
  padding: 14px 36px 14px 20px;
}

.PromoCard.compact > .header > span {
  font-size: 16px;
}

.PromoCard > .body {
  padding: 24px 30px;
  font-size: 14px;
  line-height: 1.6;
  display: grid;
  justify-items: center;
}

.PromoCard.compact > .body {
  padding: 20px 16px 24px;
}

.PromoCard > .body > .subtitle {
  font-size: 17px;
  font-weight: bold;
  margin: 0 0 20px;
  max-width: 520px;
}

.PromoCard > .body > .section {
  margin-bottom: 18px;
  width: 100%;
  max-width: 520px;
}

.PromoCard > .body > .section > .sectionTitle {
  font-weight: bold;
  margin-bottom: 8px;
  font-size: 15px;
}

.PromoCard > .body > .section > .sectionText {
  margin: 0 0 4px;
}

.PromoCard > .body > .section > .phonesGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 12px;
  width: 100%;
  justify-items: center;
}

.PromoCard > .body > .section > .phonesGrid > .phoneLink {
  white-space: nowrap;
  color: #c77a00;
  font-weight: bold;
}

.PromoCard > .body > .section.conditionsSection {
  background-color: #fff;
  border: 2px solid #c77a00;
  border-radius: 6px;
  padding: 10px 14px;
  max-width: 540px;
  margin-bottom: 12px;
}

.PromoCard > .body > .section.conditionsSection > .sectionTitle {
  font-size: 15px;
  color: #c77a00;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 6px;
}

.PromoCard > .body > .section.conditionsSection > ul {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  row-gap: 4px;
}

.PromoCard > .body > .section.conditionsSection > ul > li {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  padding: 4px 0;
  border-bottom: 1px solid #ede4df;
}

.PromoCard > .body > .section.conditionsSection > ul > li:last-child {
  border-bottom: none;
}

.PromoCard > .body > .section.important {
  background-color: rgba(237, 65, 65, 0.08);
  border-radius: 8px;
  padding: 14px 16px;
}

.PromoCard > .body > .section.important > .importantTitle {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
}

.PromoCard > .body > .section.important > .sectionText {
  font-weight: bold;
}

.PromoCard > .body a {
  color: #c77a00;
  font-weight: bold;
}

.PromoCard > .body > .footer {
  margin-top: 8px;
  font-style: italic;
  max-width: 520px;
}

.PromoCard :deep(.highlightLux) {
  color: #ed4141;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
